"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.show = show;
exports.default = void 0;

var _type = babelHelpers.interopRequireDefault(require("components/Notifications/type.catalogPost"));

var _type2 = babelHelpers.interopRequireDefault(require("components/Notifications/type.catalogReplies"));

var _type3 = babelHelpers.interopRequireDefault(require("components/Notifications/type.catalogFeedback"));

var _type4 = babelHelpers.interopRequireDefault(require("components/Notifications/type.submissionCreated"));

var _type5 = babelHelpers.interopRequireDefault(require("components/Notifications/type.topicSubmitted"));

var _type6 = babelHelpers.interopRequireDefault(require("components/Notifications/type.eventSubmitted"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _PromiseRenderer = babelHelpers.interopRequireDefault(require("PromiseRenderer"));

var _decorators = require("decorators");

var _locations = babelHelpers.interopRequireDefault(require("locations"));

var _userProfile = require("user-profile");

var _carousel = babelHelpers.interopRequireDefault(require("carousel"));

var _class, _class2, _temp, _class3, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _temp2;

var Types = {
  catalogPost: _type.default,
  catalogReplies: _type2.default,
  catalogFeedback: _type3.default,
  submissionCreated: _type4.default,
  topicSubmitted: _type5.default,
  eventSubmitted: _type6.default
};

function show(node, feedbackOnly, group, controls, callback) {
  _reactDom.default.render(_react.default.createElement(ActivityFeed, {
    feedbackOnly: feedbackOnly,
    group: group,
    controls: controls,
    callback: callback
  }), node);
}

var Feed = (_class = (_temp = _class2 =
/*#__PURE__*/
function () {
  babelHelpers.createClass(Feed, null, [{
    key: "get",
    value: function get(path) {
      return Feed.feeds[path] || (Feed.feeds[path] = new Feed(path));
    }
  }]);

  function Feed(path) {
    babelHelpers.classCallCheck(this, Feed);
    this.path = path;
    this.listening = []; // this.refresh();
  }

  babelHelpers.createClass(Feed, [{
    key: "refresh",
    value: function refresh() {
      var feed = (0, _fetch.default)(this.path).then(function (r) {
        return r.json();
      });
      if (!this.feed) this.feed = feed;
      feed.then(this.updated);
    }
  }, {
    key: "listen",
    value: function listen(C) {
      if (this.listening.indexOf(C) == -1) this.listening.push(C);
    }
  }, {
    key: "unlisten",
    value: function unlisten(C) {
      var idx = this.listening.indexOf(C);
      if (idx != -1) this.listening.splice(idx, 1);
    }
  }, {
    key: "updated",
    value: function updated() {
      var _this = this;

      this.listening.forEach(function (C) {
        return C.feedUpdated(_this.feed);
      });
    }
  }]);
  return Feed;
}(), _class2.feeds = {}, _temp), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "updated", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "updated"), _class.prototype)), _class);
var ActivityFeed = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(ActivityFeed, _Component);

  function ActivityFeed() {
    var _babelHelpers$getProt;

    var _this2;

    babelHelpers.classCallCheck(this, ActivityFeed);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(ActivityFeed)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "feedbackOnly", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "group", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "record", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "controls", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "feedback", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "handleLink", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "callback", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    _this2._mediaQueryListener = _this2._getMediaQueryListener();
    _this2.state = {
      activityFeed: _this2.feedback ? _promisePolyfill.default.resolve(_this2.feedback.feed) : null,
      count: _this2._mediaQueryListener.matches ? 1 : 2
    };
    return _this2;
  }

  babelHelpers.createClass(ActivityFeed, [{
    key: "_getMediaQueryListener",
    value: function _getMediaQueryListener() {
      if (typeof window == 'undefined' || !window.matchMedia) return {
        matches: false,
        addListener: function addListener() {},
        removeListener: function removeListener() {}
      };
      var mm = window.matchMedia('(max-width: 767px)'); // mm.addListener(this._mediaChanged);

      return mm;
    }
  }, {
    key: "_mediaChanged",
    value: function _mediaChanged() {
      this.setState({
        count: this._mediaQueryListener.matches ? 1 : 2
      });
    }
  }, {
    key: "feedUpdated",
    value: function feedUpdated(promise) {
      this.setState({
        activityFeed: promise
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.feedback) {
        var qs = [];
        if (this.feedbackOnly) qs.push('feedback=true');
        if (this.record) qs.push('record=' + this.record);else if (this.group) qs.push('group=' + this.group);
        if (qs.length) qs = "?".concat(qs.join('&'));
        var f = Feed.get("data/discussion-activity".concat(qs));
        f.listen(this);
        f.refresh();
        this.setState({
          activityFeedBase: f,
          activityFeed: f.feed || null
        });
      }

      this._mediaQueryListener.addListener(this._mediaChanged);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this3 = this;

      if (this.props.feedback !== prevProps.feedback) {
        this.setState({
          activityFeed: this.feedback ? _promisePolyfill.default.resolve(this.feedback.feed) : null
        });
      }

      if (prevState.activityFeed != this.state.activityFeed) {
        if (this.state.activityFeed) {
          this.state.activityFeed.then(function (feed) {
            return _this3.callback(feed.filter(function (item) {
              return item.linkTarget;
            }).length);
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._mediaQueryListener.removeListener(this._mediaChanged);

      if (!this.feedback) {
        this.state.activityFeedBase.unlisten(this);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_PromiseRenderer.default, {
        promise: this.state.activityFeed,
        success: this._renderSuccess
      });
    }
  }, {
    key: "_selectedNotification",
    value: function _selectedNotification(notification, shiftKey) {
      if (notification.linkTarget) {
        var T = (0, _locations.default)(notification.linkTarget);

        if (window.history) {
          window.history.pushState({}, "", T);
          (0, _userProfile.userProfileUpdated)();
        } else {
          location.href = T;
        }
      }
    }
  }, {
    key: "_renderSuccess",
    value: function _renderSuccess(data) {
      var _this4 = this;

      // FIXME: Carousel @stepCount doesn't exist yet.
      var d = data.filter(function (node) {
        return node.linkTarget;
      });
      if (!d.length) return null;
      return _react.default.createElement("div", {
        className: "activity-feed-body"
      }, _react.default.createElement(_carousel.default, {
        noControls: !this.controls,
        period: 6000,
        infinite: true,
        stepCount: this.state.count
      }, d.map(function (node, index) {
        var Type = Types[node.type];
        return _react.default.createElement(Type, {
          asLink: true,
          onSelected: _this4.handleLink || _this4._selectedNotification,
          key: index,
          item: node
        });
      })));
    }
  }]);
  return ActivityFeed;
}(_react.Component), _temp2), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "feedbackOnly", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "group", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "record", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "controls", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "feedback", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "handleLink", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "callback", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "_mediaChanged", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "_mediaChanged"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "feedUpdated", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "feedUpdated"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "_selectedNotification", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "_selectedNotification"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "_renderSuccess", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "_renderSuccess"), _class3.prototype)), _class3);
exports.default = ActivityFeed;